import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
//
import { persistor, store } from "./store";
import Routes from "./routes";
import { RecoilRoot } from "recoil";

function App() {
  return (
    <RecoilRoot>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <Routes />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </RecoilRoot>
  );
}

export default App;
